/**
 * Make the tabs show the active panel
 */
document.addEventListener('DOMContentLoaded', function() {
    let tabContainers = document.querySelectorAll('.tabbed-view');
    if(!tabContainers) return;

    tabContainers.forEach((tabContainer) => {
        let tabSelectors = tabContainer.querySelectorAll('.tab-selector');
        let tabPanels = tabContainer.querySelectorAll('.tab-panel');

        tabSelectors.forEach((selector) => {
            selector.addEventListener('click', function() {
                let targetID = selector.getAttribute('id');
                
                tabSelectors.forEach((tsel) => {
                    tsel.classList.remove('active');
                })
                tabPanels.forEach((panel) => {
                    panel.classList.remove('active');
                });

                selector.classList.toggle('active');
                tabContainer.querySelector(`.tab-panel[data-target="${targetID}"]`).classList.toggle('active');
            });
        });
    });

    let sectionContainers = document.querySelectorAll('.section-display');
    if(!sectionContainers) return;

    sectionContainers.forEach((sectionContainer) => {
        let sectionSelects = sectionContainer.querySelectorAll('.sect-selector');
        let sectionPanels = sectionContainer.querySelectorAll('.sect-panel');

        sectionSelects.forEach((sectSelect) => {
            sectSelect.addEventListener('click', function() {
                let targetSectID = sectSelect.getAttribute('id');

                sectionSelects.forEach((ssel) => {
                    ssel.classList.remove('active');
                });
                sectionPanels.forEach((ssel) => {
                    ssel.classList.remove('active');
                });

                sectSelect.classList.toggle('active');
                sectionContainer.querySelector(`.sect-panel[data-target="${targetSectID}"]`).classList.toggle('active');
            });
        });
    });

    let subSectionContainers = document.querySelectorAll('.sub-sections');
    if(!subSectionContainers) return;

    subSectionContainers.forEach((subSectionContainer) => {
        let subSectionSelects = subSectionContainer.querySelectorAll('.sub-sect-selector');
        let subSectionPanels = subSectionContainer.querySelectorAll('.sub-sect-panel');

        subSectionSelects.forEach((subSectSelect) => {
            subSectSelect.addEventListener('click', function() {
                let targetSectID = subSectSelect.getAttribute('id');

                subSectionSelects.forEach((ssel) => {
                    ssel.classList.remove('active');
                });
                subSectionPanels.forEach((ssel) => {
                    ssel.classList.remove('active');
                });

                subSectSelect.classList.toggle('active');
                subSectionContainer.querySelector(`.sub-sect-panel[data-target="${targetSectID}"]`).classList.toggle('active');
            });
        });
    });
});